/**
 * Página de Carrinho de Pedido
 */

import React from 'react';
import { Layout, PainelPedido } from '@components';
import CarrinhoPedido from '../components/carrinho/CarrinhoPedido';
import { CarrinhoProvider } from '@contexts';

const CarrinhoPedidoPage: React.FC = () => {
  return (
    <Layout title="Carrinho de Pedido" showHeader showFooter footerType="default" showPainelPedido>
      <PainelPedido />
      <CarrinhoProvider tipo="pedido">
        <CarrinhoPedido />
      </CarrinhoProvider>
    </Layout>
  );
};

export default CarrinhoPedidoPage;
